import Configuration from '@/agilis/util/Configuration'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'

import { mapActions } from 'vuex'

// Mixin providing common table actions
// Dependencies:
// - configurationMixin
export default {
  name: 'DataTableActionsMixin',

  components: {
    UnStyledLink
  },

  data () {
    return {
      showDeleteDialog: false
    }
  },

  computed: {
    routeName () {
      return this.$route.name ? this.$route.name : 'applicationWorkspace'
    }
  },

  methods: {
    ...mapActions({
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),
    createItem (itemDTO) {
      this.itemDTO = this.setContext(Object.assign({}, itemDTO))
      this.$router.agilis.create({ trackerTypeId: this.trackerTypeId, routeName: this.routeName })
    },

    viewItem (item, event) {
      this.itemDTO = Object.assign({}, item)
      this.$router.agilis.view({ trackerId: item.id, routeName: this.routeName })
    },

    editItem (item, event) {
      this.itemDTO = Object.assign({}, item)
      this.$router.agilis.edit({
        trackerId: item.id,
        routeName: this.routeName
      })
    },

    handleCopyItem (item) {
      if (this.userCanAccessFeatureDataTable('deepCopy')) {
        const userConfirmPromise = this.notifyUserConfirm({
          title: this.$t(this.trackerType.deepCopyTitle),
          messages: this.$t(this.trackerType.deepCopyDescription),
          confirm: this.deleteYes,
          cancel: this.deleteNo
        })

        userConfirmPromise.then((userResponse) => {
          if (userResponse) {
            this.deepCopy(item.id)
          }
        })
      } else {
        this.copyItem(item)
      }
    },

    deepCopy (trackerId) {
      const url = this.$axios.agilisUrlTrackerCopy(this.applicationId, this.trackerTypeId, trackerId)
      this.$axios
        .post(
          url,
          trackerId,
          this.$axios.agilisRequestConfig(url))
        .then((response) => {
          this.viewItem(response.data)
        })
        .catch((error) => {
          this.notifyError(error)
        })
    },

    copyItem (item, event) {
      const itemDTO = Object.assign({}, item, { id: null, sequenceNumber: null, trackerId: null })
      Configuration.datatable.mapItemDTOForEdit(this.dataTableConfiguration, itemDTO)

      // Remove blacklisted field
      if (this.dataTableConfiguration.copyFieldExclusions && Array.isArray(this.dataTableConfiguration.copyFieldExclusions)) {
        this.dataTableConfiguration.copyFieldExclusions.forEach((field) => {
          delete itemDTO[field]
        })
      }

      this.$router.agilis.copy({
        trackerTypeId: this.trackerTypeId,
        data: itemDTO,
        routeName: this.routeName
      })
    },

    urlViewItem (item) {
      return this.$router.agilis.urlViewTracker({
        trackerId: item.id,
        trackerTypeId: this.trackerTypeId
      })
    },

    urlEditItem (item) {
      return this.$router.agilis.urlEditTracker({
        trackerId: item.id,
        trackerTypeId: this.trackerTypeId
      })
    },

    handleEditDone (item) {
      this.fetchData()
    },

    onDeleteItemDone () {
      this.fetchData()
    },

    handleCancel (item) {
    },

    handleNew () {
      this.createItem(Configuration.datatable.getDTO(this.dataTableConfiguration))
    }
  }
}
